'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmailMessageId = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getEmailMessageId = exports.getEmailMessageId = (0, _getIn2.default)(_keyPaths.EMAIL_MESSAGE_ID);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/email-message-metadata/operators/getEmailMessageId.js
// module id = 700
// module chunks = 2 3